import React, { useEffect, useState } from 'react';
import { Modal, Col, Row, Form, Table, Alert, Button } from "react-bootstrap";
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { connect } from 'react-redux';
import { detailsActionCreators } from '../../store/DetailsStore';
import { AppState } from '../../store/configureStore';
import Skeleton from "react-loading-skeleton";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faExclamationCircle, faCheckCircle, faPrint, faFileExcel } from '@fortawesome/pro-solid-svg-icons';
import NumberFormat from 'react-number-format';
import DatePicker from 'react-datepicker';
import ReactTooltip from 'react-tooltip';
import { Link } from 'react-router-dom';
import { Path } from '../../App';
import { schedulePaymentActionCreators } from '../../store/SchedulePaymentStore';
import ContributionSummary from '../ContributionSummary';
import { driverCntb_detailPart_detail, driverCntb_detailColumn_headings } from '../../DCR.dtos';
import { Permissions } from '../../store/HelperStore';
import { hasPermission } from '../../functions/hasPermission';
import { historyActionCreators } from '../../store/HistoryStore';
type TContributionDetailsProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const ContributionDetails = (props: TContributionDetailsProps) => {

    const printContributionDetailsFormRef = React.useRef<HTMLFormElement>(null);
    const generateChangeLogReportFormRef = React.useRef<HTMLFormElement>(null);

    const isErr = props.cmDetails.error
    const [selectedPage, setSelectedPage] = useState(1);
    const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(50);
    const [selectedAll, setSelectedAll] = useState("y");
    const [isAddMode, setIsAddMode] = useState(true);
    const numberOfRows = ["25", "50", "75", "100", "300"];
    const [isPageDataLoaded, setIsPageDataLoaded] = useState(false);
    const [showAddPopup, setShowAddPopup] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [editClickTr, setEditClickTr] = useState(0);
    const [deleteClickTr, setDeleteClickTr] = useState(0);
    const [isSubmitClick, setIsSubmitClick] = useState(false);
    const [isDeleteSubmitClick, setIsDeleteSubmitClick] = useState(false);
    const [showEditDetailsLink, setShowEditDetailsLink] = useState(false);

    const [errorMessageIdentifier, setErrorMessageIdentifier] = useState("");
    const [errorCSSForSSN, setErrorCSSForSSN] = useState("");
    const [isRequiredFieldEmpty, setIsRequiredFieldEmpty] = useState(true);
    const [errorCSSForPayrollDate, setErrorCSSForPayrollDate] = useState("");

    const [isErrorOnSubmit, setIsErrorOnSubmit] = useState(false);
    const [errorMessageOnSubmit, setErrorMessageOnSubmit] = useState("");
    const [errorTypeOnSubmit, setErrorTypeOnSubmit] = useState("");

    const [isErrorOnDeleteSubmit, setIsErrorOnDeleteSubmit] = useState(false);
    const [errorMessageOnDeleteSubmit, setErrorMessageOnDeleteSubmit] = useState("");
    const [errorTypeOnDeleteSubmit, setErrorTypeOnDeleteSubmit] = useState("");

    const [inputLength, setInputLength] = useState(11);
    const [fixedDecimalScale, setFixedDecimalScale] = useState(false);

    const [offset, setOffset] = useState(0);
    const [pptIdentifier, setPptIdentifier] = useState("");
    const [selectDate, setSelectDate] = useState<Date | null>(null);
    const [name, setName] = useState("");

    const [col4, setCol4] = useState("0.0");
    const [col5, setCol5] = useState("0.0");
    const [col6, setCol6] = useState("0.0");
    const [col7, setCol7] = useState("0.0");
    const [col8, setCol8] = useState("0.0");
    const [col9, setCol9] = useState("0.0");
    const [col10, setCol10] = useState("0.0");
    const [col11, setCol11] = useState("0.0");
    const [col12, setCol12] = useState("0.0");
    const [col13, setCol13] = useState("0.0");
    const [col14, setCol14] = useState("0.0");
    const [col15, setCol15] = useState("0.0");
    const [col16, setCol16] = useState("0.0");

    const addRecordClaim = hasPermission(Permissions.ContributionDetails_Add, props.currentUserPermissions);
    const editRecordClaim = hasPermission(Permissions.ContributionDetails_Edit, props.currentUserPermissions);

    const col2Name = props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings?.col2?.name;
    const useSSN = col2Name === "SSN"

    const allowContributionDetailsSubmit = () => {
        return ((isAddMode && !addRecordClaim) || (!isAddMode && !editRecordClaim));
    }

    const nameCol = {
        width: "187px"
    }
    const editDeleteCol = {
        width: "65px"
    }

    useEffect(() => {
        if (isAddMode) {
            if (pptIdentifier?.length === 0 || selectDate === null) {
                setIsRequiredFieldEmpty(true)
            }
            else {
                setIsRequiredFieldEmpty(false)
            }
        }
        if (!isAddMode) {
            if (selectDate === null || selectDate?.toString() === "") {
                setIsRequiredFieldEmpty(true)
            }
            else {
                setIsRequiredFieldEmpty(false)
            }
        }
    }, [isAddMode, selectDate, pptIdentifier]);


    const getPaymentStatus = () => {
        return props.cmDetails?.cmHistoryRecordStatus;
    }

    useEffect(() => {
        setIsPageDataLoaded((props.cmDetails?.isDetailsLoaded ?? false) && (props.cmDetails?.isSummaryLoaded ?? false))
        setShowEditDetailsLink(getPaymentStatus()?.toUpperCase() === "SCHEDULE PAYMENT")

    }, [props.cmDetails?.isSummaryLoaded, props.cmDetails?.isDetailsLoaded]);

    useEffect(() => {
        if (isPageDataLoaded) {
            props.fetchCMDetails(props.cmDetails?.cmDetailsInfo?.cntb_detail?.cca_id, selectedPage, selectedRowsPerPage,
                selectedAll, false, true, true);
        }
    }, [selectedAll, selectedRowsPerPage, selectedPage]);
   
    function getArrayOfObject(obj: driverCntb_detailPart_detail | driverCntb_detailColumn_headings) {
        if (!obj || obj === undefined) 
            return [{ name: "", value: "" }];
        
        const objStringArray: string[] = Object?.keys(obj);
        
        const objArray: { name: string; value: any; }[] = []
        //console.log("yup");
        //@ts-ignore
        objStringArray.forEach(key => objArray.push({ name: key, value: obj[key] }))

        return objArray;
    }


    const getFilterValue = (index?: number | null, val?: string | undefined) => {
        if (index) {
            const filterVal = getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[editClickTr])[index]?.value?.name;

            return filterVal?.replace("$", "")?.replace(",", "")
        }
        else {
            return val?.replace("$", "").replace(",", "")
        }
    }
    const setDynamicFieldValues = (val: string, fieldName: string) => {

        const filterVal = getFilterValue(null, val)?.trim() === "" ? "0.0" : getFilterValue(null, val);
        switch (fieldName?.trim()) {
            case 'col4':
                setCol4(filterVal)
                break;
            case 'col5':
                setCol5(filterVal)
                break;
            case 'col6':
                setCol6(filterVal)
                break;
            case 'col7':
                setCol7(filterVal)
                break;
            case 'col8':
                setCol8(filterVal)
                break;
            case 'col9':
                setCol9(filterVal)
                break;
            case 'col10':
                setCol10(filterVal)
                break;
            case 'col11':
                setCol11(filterVal)
                break;
            case 'col12':
                setCol12(filterVal)
                break;
            case 'col13':
                setCol13(filterVal)
                break;
            case 'col14':
                setCol14(filterVal)
                break;
            case 'col15':
                setCol15(filterVal)
                break;
            case 'col16':
                setCol16(filterVal)
                break;
            default:
                return '';
        }
    }

    const valForEditMode = () => {
        getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings).forEach((item, i) => {
            if (i > 2) {
                setDynamicFieldValues(getFilterValue(i), getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[i]?.name)
            }
        }
        )
    }
    useEffect(() => {
        if (isPageDataLoaded) {
            valForEditMode();
        }
    }, [editClickTr]);

    const getOffset = () => {
        setOffset(props.cmDetails?.cmSummaryInfo?.summary?.contribs?.find(x => x.name === "Payment Account:") ? 4 : 3)
    }
    useEffect(() => {
        if (isPageDataLoaded) {
            getOffset();
        }

    }, [isPageDataLoaded, props.cmDetails?.isSummaryLoaded]);

    useEffect(() => {
        if (props.cmDetails.isNameLoaded) {
            setName(props.cmDetails?.nameBySSNUMCInfo?.name)
        }
    }, [props.cmDetails?.isNameLoaded]);

    const clearData = () => {
        setPptIdentifier("")
        setSelectDate(null)
        setErrorMessageIdentifier("")
        setErrorCSSForSSN("")
        setErrorCSSForPayrollDate("")
        setIsErrorOnSubmit(false)
        setErrorMessageOnSubmit("")
        setErrorTypeOnSubmit("")
        setName("")
        setCol4("0.00")
        setCol5("0.00")
        setCol6("0.00")
        setCol7("0.00")
        setCol8("0.00")
        setCol9("0.00")
        setCol10("0.00")
        setCol11("0.00")
        setCol12("0.00")
        setCol13("0.00")
        setCol14("0.00")
        setCol15("0.00")
        setCol16("0.00")
    }

    useEffect(() => {
        if (props.cmDetails.isAddEditSuccess && isSubmitClick) {
            if (props.cmDetails.cmAddEditInfo !== null
                && props.cmDetails?.cmAddEditInfo?.addEditResponse
                && props.cmDetails?.cmAddEditInfo?.addEditResponse.msg
                && props.cmDetails?.cmAddEditInfo?.addEditResponse?.msg_type
                && props.cmDetails?.cmAddEditInfo?.addEditResponse?.msg_type?.toUpperCase() === 'E') {

                setIsErrorOnSubmit(true)

                setErrorTypeOnSubmit(props.cmDetails?.cmAddEditInfo?.addEditResponse?.msg_type)
                setErrorMessageOnSubmit(props.cmDetails?.cmAddEditInfo?.addEditResponse?.msg)
                setIsSubmitClick(false)
            }
            else {
                if (props.cmDetails?.cmAddEditInfo?.addEditResponse?.msg_type?.toUpperCase() !== 'E') {
                    props.fetchCMDetails(props.cmDetails?.cmDetailsInfo?.cntb_detail?.cca_id, selectedPage, selectedRowsPerPage,
                        selectedAll, true, true, true);
                    setShowAddPopup(false)
                    setIsSubmitClick(false)
                    clearData();
                }
            }
            props.fetchCMHistory(props.dcr?.selectedInstitution, false, true);
        }
        if (props.cmDetails.isAddEditError) {
            setIsErrorOnSubmit(true)
            setErrorMessageOnSubmit("System error - try again.  Contact Wespath if you continue to receive this message.")
            setErrorTypeOnSubmit("E")
        }

    }, [props.cmDetails?.isAddEditSuccess, props.cmDetails?.isAddEditError]);

    useEffect(() => {
        if (props.cmDetails.isRowDeleted && isDeleteSubmitClick) {
            if (props.cmDetails?.cmDeleteRowInfo !== null
                && props.cmDetails?.cmDeleteRowInfo?.addEditResponse
                && props.cmDetails?.cmDeleteRowInfo?.addEditResponse?.msg
                && props.cmDetails?.cmDeleteRowInfo?.addEditResponse?.msg_type
                && props.cmDetails?.cmDeleteRowInfo?.addEditResponse?.msg_type?.toUpperCase() === 'E') {

                setIsErrorOnDeleteSubmit(true)

                setErrorTypeOnDeleteSubmit(props.cmDetails?.cmDeleteRowInfo?.addEditResponse?.msg_type)
                setErrorMessageOnDeleteSubmit(props.cmDetails?.cmDeleteRowInfo?.addEditResponse?.msg)

                setIsDeleteSubmitClick(false)
            }
            else {
                props.fetchCMDetails(props.cmDetails?.cmDetailsInfo?.cntb_detail?.cca_id, selectedPage, selectedRowsPerPage,
                    selectedAll, true, true, true);
                setShowDeletePopup(false)
                setIsDeleteSubmitClick(false)
            }
            props.fetchCMHistory(props.dcr?.selectedInstitution, false, true);
        }
        if (props.cmDetails.isRowDeleteError) {
            setIsErrorOnDeleteSubmit(true)
            setErrorMessageOnDeleteSubmit("System error - try again.  Contact Wespath if you continue to receive this message.")
            setErrorTypeOnDeleteSubmit("E")
        }

    }, [props.cmDetails?.isRowDeleted, props.cmDetails?.isRowDeleteError]);


    function getPages() {
        return Math.ceil(parseInt(props.cmDetails?.cmDetailsInfo?.cntb_detail?.recordcount) / selectedRowsPerPage);
    }

    function getRowsPerPage() {
        const tmp = [];
        for (let i = 0; i < getPages(); i++) {
            tmp.push(i);
        }
        return tmp;
    }


    const getWAndEColor = (index: number) => {
        if (props.cmDetails.cmDetailsInfo?.cntb_detail?.part_details[index]?.exception_type?.toUpperCase() === "W") {
            return "#FFB34D";
        }
        else if (props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[index]?.exception_type?.toUpperCase() === "E") {
            return "#B00E09";
        }
        else {
            return "";
        }
    }

    const getErrorType = (index?: number, type?: string) => {

        if (type) {
            return type;
        }

        if (props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[index ?? 0]?.exception_type?.toUpperCase() === "W") {
            return "W";
        }
        else if (props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[index ?? 0]?.exception_type?.toUpperCase() === "E") {
            return "E";
        }
        else {
            return "";
        }
    }

    const isWarAndExcep = () => {
        return props.cmDetails?.cmSummaryInfo?.summary.file_exceptions?.total_exceptions === "0" && props.cmDetails?.cmSummaryInfo?.summary?.file_exceptions?.total_warnings === "0"
    }

    const getErrorMessage = () => {
        return props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[editClickTr]?.message
    }

    const getFilterSSN = (ssn: string) => {
        const re = /-/gi;
        const re2 = /_/gi;
        const result = ssn.replace(re, "").replace(re2, "");
        return result;
    }

    const validateSSN = (ssnVal: string): boolean => {

        if (ssnVal && (getFilterSSN(ssnVal)?.length !== 9 || getFilterSSN(ssnVal) === "111223333" || getFilterSSN(ssnVal) === "999999999")) {
            setErrorMessageIdentifier(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings ? ("Invalid " + getArrayOfObject(props.cmDetails?.cmDetailsInfo.cntb_detail?.column_headings)[1]?.value.name) : "Payroll Date is required.")
            setIsRequiredFieldEmpty(false)
            return false;
        }
        else {
            setErrorMessageIdentifier("")
            return true;
        }
    }

    const validatePNUM = (pnumVal: string): boolean => {

        if (pnumVal.length !== 7) {
            setErrorMessageIdentifier("Invalid PNUM - invalid length")
            setIsRequiredFieldEmpty(false)
            return false;
        }
        else {
            setErrorMessageIdentifier("")
            return true;
        }
    }

    const getNameBySSNUMC = (orgId: string, ssn: string) => {
        if (validateSSN(ssn)) {
            props.fetchNameBySSNUMC(orgId, getFilterSSN(ssn))
        }
    }

    const onDateChange = (changeDate: Date | null) => {

        setSelectDate(changeDate)
        if (changeDate) {
            const dateString = (
                ('0' + (changeDate?.getMonth() + 1)).slice(-2) + '/'
                + ('0' + changeDate?.getDate()).slice(-2) + '/'
                + changeDate?.getFullYear());
            return dateString;
        }
        return "";
    }  

    const grrenColor = {
        color: "#50A167"
    }

    const exceptionTooltipColor = () => {
        return "#FFE9E9";
    }

    const exceptionTooltipBorderColor = () => {
        return "#C00E0D";
    }

    const warningTooltipColor = () => {
        return "#FFFEEB";

    }
    const warningTooltipBorderColor = () => {
        return "#C0B204";
    }

    const warningColor = {
        color: "#FFB34D"
    }
    const exeptionColor = {
        color: "#B00E09"
    }
    const divBorder = {
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "#D8D8D8"
    }



    const generateXMLForDelete = () => {

        const xmlData = '<DeleteContributions' +
            ' cca_id="' + props.cmDetails?.cmDetailsInfo?.cntb_detail?.cca_id +
            '" ssn="' + props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[deleteClickTr]?.ssn +
            '" org_id="' + props.cmDetails?.cmSummaryInfo?.summary?.org_id +
            '" updatedby="' + props.cmDetails.cmHistoryRecordUserName +
            '" file_payroll_date="' + props.cmDetails?.cmHistoryFilePayrollDate + '" />';

        return xmlData;
    }

    const generateXML = () => {

        const rootNode = "AddEditContributions";
        const rootAttribute1 = "org_id";
        const rootAttribute2 = "updatedby";
        const rootAttribute3 = "file_payroll_date";

        const columnHeadingsNode = "<column_headings>#AllColumns#</column_headings>";
        const participantsNode = "<participants>#participantContributions#</participants>";

        const strRootNodeWithAttribute = "<#rootNode# #rootAttribute1#=\"#valueRootAttribute1#\" #rootAttribute2#=\"#valueRootAttribute2#\" #rootAttribute3#=\"#valueRootAttribute3#\">";
        const strColumnValue = "<#id# name=\"#colVal#\" />";
        let strAllContributionValues = "<contribution #contribValues# />";
        const strContribFormat = "#colID#=\"#contribVal#\" ";
        let xmlData = "";
        let strContribValues = "";
        let strAllColumnValues = "";
        const strOldPayrollDate = !isAddMode ? (getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail.part_details[editClickTr])[2]?.value?.name) : "";
        const strFilePayrollDate = props.cmDetails?.cmHistoryFilePayrollDate ? props.cmDetails?.cmHistoryFilePayrollDate : "";

        xmlData = strRootNodeWithAttribute.replace("#rootNode#", rootNode).replace("#rootAttribute1#", rootAttribute1).replace("#valueRootAttribute1#", props.cmDetails?.cmSummaryInfo?.summary.org_id).replace("#rootAttribute2#", rootAttribute2).replace("#valueRootAttribute2#", props.cmDetails?.cmHistoryRecordUserName ?? "").replace("#rootAttribute3#", rootAttribute3).replace("#valueRootAttribute3#", strFilePayrollDate);
        let j = 0;
        for (j; j < getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)?.length; j++) {
            
            if (!(isAddMode && getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.value?.name?.toUpperCase() === 'NAME')) {
                strAllColumnValues = strAllColumnValues + strColumnValue.replace("#id#", getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#colVal#", getArrayOfObject(props.cmDetails.cmDetailsInfo.cntb_detail.column_headings)[j]?.value.name);
                if (getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.value?.name?.toUpperCase() === 'SSN') {
                    strContribValues = strContribValues + strContribFormat.replace("#colID#", getArrayOfObject(props.cmDetails.cmDetailsInfo.cntb_detail.column_headings)[j].name).replace("#contribVal#", pptIdentifier ? getFilterSSN(pptIdentifier) : props.cmDetails.cmDetailsInfo.cntb_detail.part_details[editClickTr]?.ssn);
                }
                else if (getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.value?.name?.toUpperCase() === 'PNUM') {
                    strContribValues = strContribValues + strContribFormat.replace("#colID#", getArrayOfObject(props.cmDetails.cmDetailsInfo.cntb_detail.column_headings)[j].name).replace("#contribVal#", pptIdentifier ? pptIdentifier : props.cmDetails.cmDetailsInfo.cntb_detail.part_details[editClickTr].col2.name.trim());
                }
                else if (getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.value?.name?.toUpperCase() === 'PAYROLL DATE') {
                    strContribValues = strContribValues + strContribFormat.replace("#colID#", getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", onDateChange(selectDate));
                }
                else {
                    switch (getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name?.trim()) {
                        case 'col1':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail.column_headings)[j]?.name).replace("#contribVal#", isAddMode ? name : getArrayOfObject(props.cmDetails.cmDetailsInfo.cntb_detail.part_details[editClickTr])[j].value.name);
                            break;
                        case 'col2':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', 'col2').replace("#contribVal#", 'ssn');
                            break;
                        case 'col4':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", col4);
                            break;
                        case 'col5':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", col5);
                            break;
                        case 'col6':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", col6);
                            break;
                        case 'col7':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", col7);
                            break;
                        case 'col8':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", col8);
                            break;
                        case 'col9':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", col9);
                            break;
                        case 'col10':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", col10);
                            break;
                        case 'col11':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", col11);
                            break;
                        case 'col12':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", col12);
                            break;
                        case 'col13':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", col13);
                            break;
                        case 'col14':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", col14);
                            break;
                        case 'col15':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", col15);
                            break;
                        case 'col16':
                            strContribValues = strContribValues + strContribFormat.replace('#colID#', getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[j]?.name).replace("#contribVal#", col16);
                            break;
                    }
                }
            }
        }

        const nextIndex = j + 1;
        //Additional XML adjustments for fields not  visible on UI and not a part of dynemic array.
        strAllColumnValues = strAllColumnValues + strColumnValue.replace("#id#", "col" + nextIndex).replace("#colVal#", "Old Payroll Date");

        strContribValues = strContribValues + strContribFormat.replace("#colID#", "col" + nextIndex).replace("#contribVal#", strOldPayrollDate);
        strContribValues = strContribValues + strContribFormat.replace("#colID#", "seqnum").replace("#contribVal#", !isAddMode ? props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[editClickTr]?.seqnum : "");

        xmlData = xmlData + columnHeadingsNode.replace("#AllColumns#", strAllColumnValues);

        strAllContributionValues = strAllContributionValues.replace("#contribValues#", strContribValues);
        xmlData = xmlData + participantsNode.replace("#participantContributions#", strAllContributionValues);
        xmlData = xmlData + '</AddEditContributions>';

        return xmlData;
    }

    const addEdit = () => {
        setIsSubmitClick(true)
        const xmlInput = generateXML();
        props.fetchAddEdit(xmlInput, "")
    }
    const deleteRow = () => {
        setIsDeleteSubmitClick(true)
        const xmlInput = generateXMLForDelete();
        props.fetchDeleteRow(xmlInput)
    }

    const getInstitutionName = (): string | undefined => {
        if (props.currentUser) {
            return props.currentUser?.institutions.find(x => x.value === props.dcr?.selectedInstitution)?.display;
        }
        return "";
    }

    const printContributionDetailsPDF = () => printContributionDetailsFormRef?.current?.submit();

    const generateChangeLogReport = () => generateChangeLogReportFormRef?.current?.submit();


    const isEbillerAutoPending = () => {

        return ((getPaymentStatus()?.toUpperCase() === "PENDING")
            && props.cmDetails?.cmHistoryRecordOrgType?.toUpperCase() === "E"
            && props.cmDetails?.cmHistoryRecordSchedType === "A");
    }

    const showCancelButton = () => {
        return ((getPaymentStatus()?.toUpperCase() === "PENDING") &&
            (props.cmDetails?.cmHistoryRecordOrgType?.toUpperCase() === "U"
                || props.cmDetails?.cmHistoryRecordSchedType?.toUpperCase() === "M"));
    }

    const HeaderText = () => (
        <>
            <h4 className="float-left">Contribution Details</h4>
        </>
    )

    const ChangeLogReportLink = (btnProps: { screenMode: string }) => {

        return (
            <>
                {props.cmDetails?.isLoading && <div className="mb-1"><LoadingForNameBySSN /> </div>}
                {!props.cmDetails?.isLoading &&
                    <>
                        <div className={btnProps.screenMode.trim().toUpperCase() === "SMALL" ? "align-self-center my-1" : "align-self-center align-middle text-nowrap"}
                            style={btnProps.screenMode.trim().toUpperCase() !== "SMALL" ? { float: "right" } : { textAlign: "center" }}>
                            {btnProps.screenMode.trim().toUpperCase() !== "SMALL" && <span className="mx-2">|</span>}
                            <a style={{ cursor: "pointer" }} onClick={() => { generateChangeLogReport() }}>
                                <span className={btnProps.screenMode.trim().toUpperCase() === "SMALL" ? "text-nowrap text-center" : "text-nowrap"}>
                                    <FontAwesomeIcon className="align-middle mr-1" icon={faFileExcel} /><span style={{ textDecoration: "underline" }}>Change Log (Excel)</span>
                                </span>
                            </a>
                        </div>
                        <form ref={generateChangeLogReportFormRef} method="POST" action={`${process.env.REACT_APP_API_URL}/ChangeLog`} target="_blank">
                            <input type="hidden" name="contextToken" value={sessionStorage.getItem("CM.ContextToken") ?? ""} />
                            <input type="hidden" name="ccaId" value={props.cmDetails?.cmDetailsInfo?.cntb_detail?.cca_id} />
                        </form>
                    </>
                }
            </>
        )
    }

    const CancelPaymentButton = (btnProps: { screenMode: string; isDisable: boolean }) => {

        return (
            <>
                <div className={btnProps.screenMode.trim().toUpperCase() === "SMALL" ? "col-12 pt-0 my-1" : "mr-3"}>
                    {props.cmDetails?.isLoading && <div className="mb-1"><LoadingForNameBySSN /> </div>}
                    {!props.cmDetails?.isLoading &&
                        <>
                            <Link to={Path.ContributionCancelPayment} style={{ textDecoration: "none" }}>
                                <button type="button" disabled={btnProps.isDisable}
                                    className="btn btn-primary btn-block mb-1 custom-primary-btn" style={btnProps.screenMode.trim().toUpperCase() !== "SMALL" ? { width: "fit-content" } : { textDecoration: "none" }}
                                    onClick={() => { props.setCmSchedulePaymentDefaults(props.cmDetails?.cmSummaryInfo?.summary?.contribs, offset, props.cmDetails?.cmHistoryFilePayrollDate ?? "", props.cmDetails?.cmDetailsInfo?.cntb_detail?.cca_id, props.cmDetails?.cmHistoryStatusDate ?? "", props.cmDetails?.cmHistoryScheduleDate ?? "") }} >Cancel Payment</button>
                            </Link>
                        </>
                    }
                </div>
            </>
        )
    }

    const SchedulePaymentButton = (btnProps: { screenMode: string; isDisable: boolean }) => {

        return (
            <>
                <div className={btnProps.screenMode.trim().toUpperCase() === "SMALL" ? "col-12 pt-0 my-1" : "mr-3"}>
                    {props.cmDetails?.isLoading && <div className="mb-1"><LoadingForNameBySSN /> </div>}
                    {!props.cmDetails?.isLoading &&
                        <>
                            <Link to={Path.ContributionSchedulePayment} style={{ textDecoration: "none" }}>
                                <button type="button" disabled={btnProps.isDisable}
                                    className="btn btn-primary btn-block mb-1 custom-primary-btn" style={btnProps.screenMode.trim().toUpperCase() !== "SMALL" ? { width: "fit-content" } : { textDecoration: "none" }}
                                    onClick={() => { props.setCmSchedulePaymentDefaults(props.cmDetails?.cmSummaryInfo?.summary?.contribs, offset, props.cmDetails?.cmHistoryFilePayrollDate ?? "", props.cmDetails?.cmDetailsInfo?.cntb_detail?.cca_id, props.cmDetails?.cmHistoryStatusDate ?? "", props.cmDetails?.cmHistoryScheduleDate ?? "") }} >Schedule Payment</button>
                            </Link>
                        </>
                    }
                </div>
            </>
        )
    }

    const PrintPDFButton = (btnProps: { screenMode: string }) => {
        return (
            <>
                {props.cmDetails?.isLoading && <div className="mb-1"><LoadingForNameBySSN /> </div>}
                {!props.cmDetails?.isLoading &&
                    <>
                        <div className="align-self-center" style={btnProps.screenMode.trim().toUpperCase() !== "SMALL" ? { float: "right" } : { textAlign: "center" }}>
                            <a style={{ cursor: "pointer" }} onClick={() => { printContributionDetailsPDF() }}>
                                <span className="text-nowrap">
                                    <FontAwesomeIcon className="align-middle mr-1" icon={faPrint} /><span style={{ textDecoration: "underline" }}>Print (PDF)</span>
                                </span>
                            </a>
                        </div>
                        <form ref={printContributionDetailsFormRef} method="POST" action={`${process.env.REACT_APP_API_URL}/PrintDetails`} target="_blank">
                            <input type="hidden" name="contextToken" value={sessionStorage.getItem("CM.ContextToken") ?? ""} />
                            <input type="hidden" name="ccaId" value={props.cmDetails?.cmDetailsInfo?.cntb_detail?.cca_id} />
                            <input type="hidden" name="payrollDate" value={props.cmDetails?.cmHistoryFilePayrollDate ?? ""} />
                            <input type="hidden" name="status" value={props.cmDetails.cmHistoryRecordStatus ?? ""} />
                            <input type="hidden" name="statusDate" value={props.cmDetails.cmHistoryStatusDate ?? ""} />
                            <input type="hidden" name="totalRecords" value={props.cmDetails?.cmDetailsInfo?.cntb_detail?.recordcount} />
                            <input type="hidden" name="organization" value={getInstitutionName() ?? ""} />
                        </form>
                    </>
                }
            </>
        )
    }

    const AddRecordButton = (btnProps: { screenMode: string }) => {
        return (
            <div className={btnProps.screenMode.trim().toUpperCase() === "SMALL" ? "col-12 mr-3 mt-1" : "mr-3"}>
                {!props.cmDetails?.isLoading &&
                    <>
                        <button type="button"
                            className="btn btn-primary btn-block custom-primary-btn" style={btnProps.screenMode.trim().toUpperCase() !== "SMALL" ? { width: "fit-content" } : { textDecoration: "none" }}
                            onClick={() => { setIsAddMode(true); clearData(); setShowAddPopup(true) }} >Add Record</button>
                    </>
                }
            </div>
        )
    }

    const GridHeaderLarge = () => (
        <>
            <Row className="tbl-info-wrap mt-2">
                <Col>
                    <Row>
                        <Col className="header-col1">
                            <HeaderText />
                        </Col>
                        {!(getPaymentStatus()?.toUpperCase() === "SCHEDULE PAYMENT" || isEbillerAutoPending()) &&
                            <>
                                <Col className="d-flex justify-content-end" style={{ display: "contents" }}>

                                    {showCancelButton() &&
                                        <>
                                            <CancelPaymentButton screenMode="Large" isDisable={false} />
                                        </>
                                    }
                                    <PrintPDFButton screenMode="Large" />
                                    {props.cmDetails?.cmHistoryRecordOrgType?.toUpperCase() === "E" &&
                                        <ChangeLogReportLink screenMode="Large" />
                                    }
                                </Col>
                            </>
                        }
                        {(getPaymentStatus()?.toUpperCase() === "SCHEDULE PAYMENT" || isEbillerAutoPending()) &&
                            <>
                                <Col className="d-flex header-col2" style={{ display: "contents" }}>
                                    <AddRecordButton screenMode="Large" />
                                    {getPaymentStatus()?.toUpperCase() === "SCHEDULE PAYMENT" &&
                                        <SchedulePaymentButton screenMode="Large" isDisable={(parseInt(props.cmDetails?.cmSummaryInfo?.summary?.file_exceptions?.total_exceptions)) > 0} />
                                    }
                                    <PrintPDFButton screenMode="Large" />
                                    {props.cmDetails?.cmHistoryRecordOrgType?.toUpperCase() === "E" &&
                                        <ChangeLogReportLink screenMode="Large" />
                                    }
                                </Col>
                            </>
                        }

                    </Row>
                </Col>
            </Row>
        </>
    )

    const GridHeaderMedium = () => (
        <>
            <Row className="tbl-info-wrap mt-2">
                <Col>
                    {!(getPaymentStatus()?.toUpperCase() === "SCHEDULE PAYMENT" || isEbillerAutoPending()) &&
                        <>
                            {showCancelButton() ?
                                <>
                                    <Row>
                                        <Col>
                                            <HeaderText />
                                        </Col>
                                    </Row>
                                    <Row className="justify-content-end">
                                        <Col className="d-inline-flex justify-content-end">
                                            <CancelPaymentButton screenMode="Medium" isDisable={false} />
                                            <PrintPDFButton screenMode="Medium" />
                                            {props.cmDetails?.cmHistoryRecordOrgType?.toUpperCase() === "E" &&
                                                <ChangeLogReportLink screenMode="Medium" />
                                            }
                                        </Col>
                                    </Row>
                                </>
                                :
                                <>
                                    <Row>
                                        <Col>
                                            <HeaderText />
                                        </Col>
                                        <Col className="d-inline-flex justify-content-end">
                                            <PrintPDFButton screenMode="Medium" />
                                            {props.cmDetails?.cmHistoryRecordOrgType?.toUpperCase() === "E" &&
                                                <ChangeLogReportLink screenMode="Medium" />
                                            }
                                        </Col>
                                    </Row>
                                </>
                            }
                        </>
                    }
                    {(getPaymentStatus()?.toUpperCase() === "SCHEDULE PAYMENT" || isEbillerAutoPending()) &&
                        <>
                            <Row>
                                <Col>
                                    <HeaderText />
                                </Col>
                            </Row>
                            <Row className="justify-content-end">
                                <Col className="d-inline-flex justify-content-end">
                                    <AddRecordButton screenMode="Medium" />
                                    {getPaymentStatus()?.toUpperCase() === "SCHEDULE PAYMENT" &&
                                        <SchedulePaymentButton screenMode="Medium" isDisable={(parseInt(props.cmDetails?.cmSummaryInfo?.summary?.file_exceptions?.total_exceptions)) > 0} />
                                    }
                                    <PrintPDFButton screenMode="Medium" />
                                    {props.cmDetails?.cmHistoryRecordOrgType?.toUpperCase() === "E" &&
                                        <ChangeLogReportLink screenMode="Medium" />
                                    }
                                </Col>
                            </Row>
                        </>
                    }
                </Col>
            </Row>
        </>
    )

    const GridHeaderSmall = () => (
        <>
            <Row className="tbl-info-wrap mt-2">
                <Col>
                    <Row>
                        <Row className="w-100">
                            <Col>
                                <HeaderText />
                            </Col>
                        </Row>
                        {!(getPaymentStatus()?.toUpperCase() === "SCHEDULE PAYMENT" || isEbillerAutoPending()) &&
                            <>
                                <Col className="col-12">

                                    {showCancelButton() &&
                                        <>
                                            <CancelPaymentButton screenMode="Small" isDisable={false} />
                                        </>
                                    }

                                </Col>
                                <Col className="col-12">
                                    <PrintPDFButton screenMode="Small" />
                                </Col>
                                {props.cmDetails?.cmHistoryRecordOrgType?.toUpperCase() === "E" &&
                                    <Col className="col-12">
                                        <ChangeLogReportLink screenMode="Small" />
                                    </Col>
                                }
                            </>
                        }
                        {(getPaymentStatus()?.toUpperCase() === "SCHEDULE PAYMENT" || isEbillerAutoPending()) &&
                            <>
                                <Col className="col-12">
                                    <AddRecordButton screenMode="Small" />
                                </Col>
                                <Col className="col-12">
                                    {getPaymentStatus()?.toUpperCase() === "SCHEDULE PAYMENT" &&
                                        <SchedulePaymentButton screenMode="Small" isDisable={(parseInt(props.cmDetails?.cmSummaryInfo?.summary?.file_exceptions?.total_exceptions)) > 0} />
                                    }
                                </Col>
                                <Col className="col-12">
                                    <PrintPDFButton screenMode="Small" />
                                </Col>
                                {props.cmDetails?.cmHistoryRecordOrgType?.toUpperCase() === "E" &&
                                    <Col className="col-12">
                                        <ChangeLogReportLink screenMode="Small" />
                                    </Col>
                                }
                            </>
                        }

                    </Row>
                </Col>
            </Row>
        </>
    )

    return (

        <>
            {!isErr ?
                <>
                    {!isPageDataLoaded && <LoadingSkeleton />}

                    {isPageDataLoaded &&
                        <Row className="mb-2">
                            <Col>
                                <div>
                                    <>
                                        {props.cmDetails.isDetailsLoaded &&
                                            <>
                                                <div className="col-12 col-xl-9 mb-3 mb-md-0" style={{ float: "left" }}>
                                                    <Row className="mt-2">
                                                        <Col>
                                                            <div className="d-none d-lg-block">
                                                                <GridHeaderLarge />
                                                            </div>
                                                            <div className="d-none d-md-block d-lg-none">
                                                                <GridHeaderMedium />
                                                            </div>
                                                            <div className="d-xs-block d-sm-block d-md-none">
                                                                <GridHeaderSmall />
                                                            </div>
                                                            {Math.ceil(parseInt(props.cmDetails?.cmDetailsInfo?.cntb_detail?.recordcount)) > 50 &&
                                                                <>
                                                                    <Row className="form-group form-inline d-block d-sm-none float-left">
                                                                        <Col style={{ display: "flex", justifyContent: "flex-end" }}>
                                                                            {props.cmDetails?.isLoading && <div className="mb-1"><LoadingForNameBySSN /> </div>}
                                                                            {!props.cmDetails?.isLoading &&
                                                                                <>
                                                                                    <label className="m-2">Viewing </label>
                                                                                    <select className="form-control m-2" style={{ width: "75px" }} value={selectedPage} id="drpdwnPageNumber" onChange={(e) => { setSelectedPage(parseInt(e.target.value)) }}>
                                                                                        {getRowsPerPage().map((item, i) =>
                                                                                            <option value={item + 1} key={i}>{item + 1}</option>
                                                                                        )}
                                                                                    </select>
                                                                                    <label className="m-2">of {getPages()} pages. </label> <br />
                                                                                </>
                                                                            }
                                                                        </Col>
                                                                        <Col style={{ display: "flex", justifyContent: "flex-end" }}>
                                                                            {props.cmDetails?.isLoading && <div className="mb-1"><LoadingForNameBySSN /> </div>}
                                                                            {!props.cmDetails?.isLoading &&
                                                                                <>
                                                                                    <label className="m-2">View </label>
                                                                                    <select className="form-control m-2" style={{ width: "75px" }} value={selectedRowsPerPage} onChange={(e) => { setSelectedRowsPerPage(parseInt(e.target.value)); setSelectedPage(1) }} id="drpdwnRowCount">
                                                                                        {numberOfRows.map((item, i) =>
                                                                                            <option value={item} key={i}>{item}</option>
                                                                                        )}
                                                                                    </select>
                                                                                    <label className="m-2">rows per page. </label>
                                                                                </>
                                                                            }


                                                                        </Col>

                                                                    </Row>
                                                                    <Row className="form-group form-inline d-none d-sm-block">

                                                                        <Col style={{ display: "flex", justifyContent: "flex-end" }}>
                                                                            {props.cmDetails?.isLoading && <div className="mb-1"><LoadingForNameBySSN /> </div>}
                                                                            {!props.cmDetails?.isLoading &&
                                                                                <>
                                                                                    <label className="ml-2">Viewing </label>
                                                                                    <select className="form-control m-2" style={{ width: "75px" }} value={selectedPage} id="drpdwnPageNumber" onChange={(e) => { setSelectedPage(parseInt(e.target.value)) }}>
                                                                                        {getRowsPerPage().map((item, i) =>
                                                                                            <option value={item + 1} key={i}>{item + 1}</option>
                                                                                        )}
                                                                                    </select>
                                                                                    <label className="mr-3">  of {getPages()} pages. </label>
                                                                                </>
                                                                            }

                                                                            {props.cmDetails?.isLoading && <div className="mb-1"><LoadingForNameBySSN /> </div>}
                                                                            {!props.cmDetails?.isLoading &&
                                                                                <>
                                                                                    <label>View </label>
                                                                                    <select className="form-control m-2" style={{ width: "75px" }} value={selectedRowsPerPage} onChange={(e) => { setSelectedRowsPerPage(parseInt(e.target.value)); setSelectedPage(1) }} id="drpdwnRowCount">
                                                                                        {numberOfRows.map((item, i) =>
                                                                                            <option value={item} key={i}>{item}</option>
                                                                                        )}
                                                                                    </select>
                                                                                    <label>rows per page. </label>
                                                                                </>
                                                                            }


                                                                        </Col>
                                                                    </Row>
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>


                                                    <div className="widetable  widetable-min-width widetable-overflow-ffx cmDetailsTable">
                                                        {props.cmDetails.isLoading && <LoadingSkeletonForTable />}
                                                        {!props.cmDetails.isLoading &&
                                                            <>
                                                                <Table className="table table-bordered table-striped table-fixed" style={{ fontSize: "14px", borderBottom: "0px" }}>
                                                                    <thead>
                                                                        <tr className="border-bottom pl-2 table-borderless" style={{ display: "table", width: "100%", tableLayout: "fixed", minWidth: "880px" }}>
                                                                            {props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings &&
                                                                                <>
                                                                                    {props.cmDetails?.isLoading && <LoadingSkeletonForTable />}
                                                                                    {!props.cmDetails?.isLoading &&
                                                                                        <>
                                                                                            {getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings).map((item, i) =>
                                                                                                <th style={i === 0 ? nameCol : {}} key={i}>
                                                                                                    {item.value.name}
                                                                                                </th>
                                                                                            )}
                                                                                            {(showEditDetailsLink || isEbillerAutoPending()) &&
                                                                                                <th style={editDeleteCol} key={123}>
                                                                                                </th>
                                                                                            }
                                                                                        </>
                                                                                    }
                                                                                </>
                                                                            }
                                                                        </tr>
                                                                    </thead>

                                                                    <tbody style={(Math.ceil(parseInt(props.cmDetails?.cmDetailsInfo?.cntb_detail?.recordcount)) > 50) ? { height: "280px" } : { height: "330px" }}>
                                                                        {props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details.map((item, trKey) =>
                                                                            <tr key={trKey} style={{ display: "table", width: "100%", tableLayout: "fixed", minWidth: "880px" }}>
                                                                                {getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[trKey])?.map((tdItem, tdKey) =>
                                                                                    tdItem.name.includes("col") &&

                                                                                    <td style={tdKey === 0 ? { width: nameCol.width, color: getWAndEColor(trKey) } : { color: getWAndEColor(trKey) }} key={tdKey} className="pl-2 history-tooltip">
                                                                                        {(tdKey === 0) ?
                                                                                            <>
                                                                                                {getErrorType(trKey)?.toUpperCase() === "W" &&
                                                                                                    <>
                                                                                                        <div className="link-effect">
                                                                                                            <p className="tableTdSpacing" data-for='test1' data-tip={"Compensation : " + props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[trKey]?.compensation + "<br />" +
                                                                                                                "Compensation Effective Date : " + props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[trKey]?.effective_date + "<br />" +
                                                                                                                props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[trKey]?.message
                                                                                                            }
                                                                                                            >
                                                                                                                {tdItem.value.name}
                                                                                                            </p>
                                                                                                            <ReactTooltip className="border border-warning" html={true} id='test1' backgroundColor={warningTooltipColor()} textColor="#FFB34D" border={true} borderColor={warningTooltipBorderColor()} />
                                                                                                        </div>
                                                                                                    </>
                                                                                                }

                                                                                                {getErrorType(trKey)?.toUpperCase() === "E" &&
                                                                                                    <>
                                                                                                        <div className="link-effect">
                                                                                                            <p className="tableTdSpacing" data-for='test2' data-tip={"Compensation : " + props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[trKey]?.compensation + "<br />" +
                                                                                                                "Compensation Effective Date : " + props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[trKey]?.effective_date + "<br />" +
                                                                                                                props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[trKey]?.message
                                                                                                            }
                                                                                                            >
                                                                                                                {tdItem.value.name}
                                                                                                            </p>


                                                                                                            <ReactTooltip className="border border-danger" html={true} id='test2' backgroundColor={exceptionTooltipColor()} textColor="#B00E09" border={true} borderColor={exceptionTooltipBorderColor()} />
                                                                                                        </div>
                                                                                                    </>
                                                                                                }
                                                                                                {getErrorType(trKey)?.toUpperCase() !== "E" && getErrorType(trKey)?.toUpperCase() !== "W" &&
                                                                                                    <>
                                                                                                        <div className="link-effect">
                                                                                                            <p className="tableTdSpacing" data-for='test3' data-tip={"Compensation : " + props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[trKey]?.compensation + "<br />" +
                                                                                                                "Compensation Effective Date : " + props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[trKey]?.effective_date + "<br />" +
                                                                                                                props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[trKey]?.message
                                                                                                            }
                                                                                                            >
                                                                                                                {tdItem.value.name}
                                                                                                            </p>
                                                                                                            <ReactTooltip className="border border-dark" html={true} id='test3' backgroundColor="#FFFFFF" textColor="#000000" border={true} borderColor="#000000" />
                                                                                                        </div>
                                                                                                    </>
                                                                                                }
                                                                                            </>
                                                                                            :
                                                                                            <>
                                                                                                {tdItem.value.name}
                                                                                            </>
                                                                                        }
                                                                                    </td>
                                                                                )}
                                                                                {(showEditDetailsLink || isEbillerAutoPending()) &&
                                                                                    <td style={editDeleteCol} className="pl-2" key={trKey + 123}>

                                                                                        {(props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[trKey]?.delete_link?.toUpperCase() !== "Y") &&
                                                                                            <span className="link-effect" style={{ color: "#0063A7" }} onClick={() => {
                                                                                                setEditClickTr(trKey); setIsAddMode(false); setShowAddPopup(true); setSelectDate(new Date(getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[trKey])[2]?.value?.name));
                                                                                                valForEditMode();
                                                                                            }}>Edit</span>
                                                                                        }
                                                                                        {(props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[trKey]?.delete_link?.toUpperCase() === "Y") &&
                                                                                            <span className="link-effect" style={{ color: "#0063A7" }} onClick={() => {

                                                                                                setDeleteClickTr(trKey);
                                                                                                setShowDeletePopup(true)
                                                                                            }}>Delete</span>
                                                                                        }
                                                                                    </td>
                                                                                }
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </Table>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {props.cmDetails.isSummaryLoaded &&
                                            <div className="col-12 col-xl-3 mt-lg-0 summarySection">
                                                {props.cmDetails?.isSummaryLoading && props.cmDetails?.isLoading ?
                                                    <LoadingSkeletonForSummary />
                                                    :
                                                    <>
                                                        <div className="contribution-summary-panel mt-2 mr-0">
                                                            <h4 className="cont-summary-bottom-border">Contribution Summary</h4>
                                                            <ContributionSummary />
                                                        </div>
                                                        <div className="contribution-summary-panel mt-2">
                                                            <h4 className="cont-summary-bottom-border">File Summary</h4>
                                                            <div>
                                                                <Row className="pnl-right-hyperlink">
                                                                    <Col>
                                                                        <div className="form-check">
                                                                            <label className="form-check-label">
                                                                                <input type="radio" value="1" defaultChecked={(selectedAll === "y")} onClick={() => { setSelectedAll("y"); setSelectedRowsPerPage(50); setSelectedPage(1) }} className="form-check-input" name="rdFileSummary" />Show all participants
                                                                    </label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <label className="form-check-label">
                                                                        <input type="radio" value="2" defaultChecked={(selectedAll === "n")} onClick={() => { setSelectedAll("n"); setSelectedRowsPerPage(50); setSelectedPage(1) }} className="form-check-input" name="rdFileSummary" />Show exceptions and warnings -  The exceptions in red must be corrected before scheduling a payment. </label>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className="pnl-right-hyperlink mt-2">
                                                                    {props.cmDetails?.cmSummaryInfo?.summary.file_exceptions?.exception &&
                                                                        <Col style={divBorder}>
                                                                            {props.cmDetails?.cmSummaryInfo?.summary.file_exceptions?.exception.map((item, i) =>
                                                                                <div className="my-2 divBorder" key={i}>

                                                                                    {(item.type.toUpperCase() === "W") &&
                                                                                        <FontAwesomeIcon icon={faExclamationTriangle} style={warningColor} className="mr-1" />
                                                                                    }
                                                                                    {(item.type.toUpperCase() === "E") &&
                                                                                        <FontAwesomeIcon icon={faExclamationCircle} className="mr-1" style={exeptionColor} />
                                                                                    }
                                                                                    <span>{item.name} &#160;-&#160; {item.count} </span>
                                                                                </div>
                                                                            )}
                                                                        </Col>
                                                                    }
                                                                    {isWarAndExcep() &&
                                                                        <Col>
                                                                            <div style={divBorder} className="m-0 p-2">
                                                                                <p>
                                                                                    <FontAwesomeIcon icon={faCheckCircle} style={grrenColor} /> No Exceptions or Warnings
                                                                        </p>
                                                                            </div>
                                                                        </Col>
                                                                    }
                                                                </Row>
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        }
                                    </>
                                    <Modal show={showAddPopup} backdrop="static" centered >
                                        <Modal.Header>
                                            <Modal.Title>{!isAddMode ? "Edit Contribution" : "Add Contribution"}</Modal.Title>
                                        </Modal.Header>
                                        {isSubmitClick && !props.cmDetails.isAddEditSuccess && <LoadingSkeletonForAddEdit />}
                                        {!(isSubmitClick && !props.cmDetails.isAddEditSuccess) &&
                                            <>
                                                <Modal.Body className="text-justify addEditModel">
                                                    {!isErrorOnSubmit && !isAddMode && getErrorMessage()?.trim() !== "" &&
                                                        <Row>
                                                            <Col className="mx-2">
                                                                <Alert className="mt-2" variant={getErrorType(editClickTr) === "E" ? "danger" : getErrorType(editClickTr) === "W" ? "warning" : ""}>
                                                                    <Row>
                                                                        <Col>
                                                                            {getErrorMessage()}
                                                                        </Col>
                                                                    </Row>
                                                                </Alert>
                                                            </Col>
                                                        </Row>
                                                    }
                                                    {isErrorOnSubmit &&
                                                        <Row>
                                                            <Col className="mx-2">
                                                                <Alert className="mt-2" variant={errorTypeOnSubmit === "E" ? "danger" : getErrorType(editClickTr) === "W" ? "warning" : ""}>
                                                                    <Row>
                                                                        <Col>
                                                                            {errorMessageOnSubmit}
                                                                        </Col>
                                                                    </Row>
                                                                </Alert>
                                                            </Col>
                                                        </Row>
                                                    }

                                                    <Form.Group>
                                                        <Row>
                                                            <Col className="col-12 col-sm-2">
                                                            <Form.Label className="control-label">
                                                                {getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[1]?.value?.name}:
                                                                {isAddMode && <span className="asterisk">&nbsp;*</span>}
                                                            </Form.Label>
                                                            </Col>
                                                            {!isAddMode &&
                                                                <>
                                                                    <Col className="col-12 col-sm-10">
                                                                        <span className="control-value">{getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail.part_details[editClickTr])[1]?.value?.name}</span>
                                                                    </Col>
                                                                </>
                                                            }
                                                        </Row>

                                                        {!isAddMode &&
                                                        <>
                                                                <Row className="my-2">
                                                                    <Col className="col-12 col-sm-2">
                                                                        <span className="control-label">{getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[0].value?.name}:</span>
                                                                    </Col>
                                                                    <Col className="col-12 col-sm-10">
                                                                        <span className="control-value">{getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.part_details[editClickTr])[0]?.value?.name}</span>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        }


                                                        {isAddMode &&
                                                        <>
                                                        {useSSN ? 
                                                            <NumberFormat
                                                                className={`${(errorCSSForSSN !== "") ? "is-error" : ""}`}
                                                                customInput={Form.Control}
                                                                format="###-##-####"
                                                                mask="_"
                                                                value={pptIdentifier}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setPptIdentifier(e.target.value); setName(""); getNameBySSNUMC(props.cmDetails?.cmSummaryInfo?.summary?.org_id, e.target.value) }}
                                                                onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                    setErrorCSSForSSN(!validateSSN(e.target.value) ? "is-error" : "");
                                                                }}
                                                                tabIndex={4}

                                                            />
                                                            :
                                                            <NumberFormat
                                                                className={`${(errorCSSForSSN !== "") ? "is-error" : ""}`}
                                                                customInput={Form.Control}
                                                                format="#######"
                                                                mask="_"
                                                                value={pptIdentifier}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setPptIdentifier(e.target.value); setName("") }}
                                                                onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                    setErrorCSSForSSN(!validatePNUM(e.target.value) ? "is-error" : "");
                                                                }}
                                                                tabIndex={4}

                                                            />
                                                        }
                                                                <div className="error-feedback">
                                                                    {errorMessageIdentifier}
                                                                </div>
                                                                <Row className="my-2">
                                                                    <Col className="col-12 col-sm-2">
                                                                        <Form.Label className="control-label">{getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[0]?.value?.name}:</Form.Label>

                                                                    </Col>
                                                                    <Col className="col-12 col-sm-10">
                                                                        {props.cmDetails.isNameLoding ?
                                                                            <LoadingForNameBySSN />
                                                                            :
                                                                            <>
                                                                                <span className="control-value">{name}</span>
                                                                                <br />
                                                                            </>
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        }

                                                        <Form.Label className="control-label">{getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[2]?.value?.name} (MM/DD/YYYY):</Form.Label>
                                                        <span className="asterisk">&nbsp;*</span>
                                                        <br />
                                                        <DatePicker
                                                            selected={selectDate}
                                                            dateFormat='MM/dd/yyyy'
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            onFocus={() => { selectDate ? setSelectDate(selectDate) : setSelectDate(new Date()) }}
                                                            strictParsing
                                                            onChange={(changeDate: Date) => { onDateChange(changeDate); setErrorCSSForPayrollDate(!changeDate ? "is-error" : "") }}

                                                            //filterDate={(date) => date.getDay() != 6 && date.getDay() != 0}                                                              
                                                            customInput={
                                                                <NumberFormat className="form-control" format="##/##/####" mask="_" value={(selectDate ? selectDate.toDateString() : null) ?? ""} />
                                                            }
                                                        />

                                                        {getArrayOfObject(props.cmDetails.cmDetailsInfo.cntb_detail.column_headings).map((item, i) =>
                                                            i > 2 &&
                                                            <div key={i}>
                                                                <Form.Label className="control-label">{getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail.column_headings)[i]?.value?.name}:</Form.Label>
                                                                <NumberFormat
                                                                    controlid={i}
                                                                    thousandSeparator={true}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={fixedDecimalScale}
                                                                    maxLength={inputLength}
                                                                    customInput={Form.Control}
                                                                    allowNegative={false}
                                                                    onKeyPress={(e) => { (e.key) === "." ? setInputLength(16) : setInputLength(inputLength) }}
                                                                    defaultValue={isAddMode ? "" : getFilterValue(i)}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setInputLength(e.target.value.includes(".") ? 14 : 11); setDynamicFieldValues(e.target.value, getArrayOfObject(props.cmDetails?.cmDetailsInfo?.cntb_detail?.column_headings)[i]?.name) }}
                                                                    onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                        setFixedDecimalScale((e.target.value.includes(".") && (e.target.value.length !== 16)))
                                                                    }}
                                                                    onFocus={() => { setFixedDecimalScale(false) }}
                                                                />
                                                            </div>
                                                        )}
                                                    </Form.Group>
                                                    <div className="mt-2 text-required">*Required Fields</div>
                                                </Modal.Body>
                                                <Modal.Footer>
                                                    <div className="w-100">
                                                        <div className="row">
                                                            <div className="d-none d-sm-block btn-block-xs-only float-left no-after col-12 col-sm-2">
                                                            </div>
                                                            <div className="col-12 col-sm-10">

                                                                <Button className="btn-block-xs-only float-right btn btn-primary" variant="primary" disabled={!allowContributionDetailsSubmit() ? (isAddMode ? (((errorCSSForSSN === "") || isRequiredFieldEmpty) ? isRequiredFieldEmpty : true) : isRequiredFieldEmpty) : true}
                                                                    onClick={() => { addEdit(); }}>Submit</Button>
                                                                <Button onClick={() => { setShowAddPopup(false); clearData(); }} className="btn-block-xs-only float-right mr-sm-3 btn btn-secondary"
                                                                    variant="secondary">Cancel</Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Modal.Footer>
                                            </>
                                        }
                                    </Modal>
                                    <Modal show={showDeletePopup} backdrop="static" centered>
                                        <Modal.Header>
                                            <Modal.Title>Delete Contribution</Modal.Title>
                                        </Modal.Header>
                                        {isDeleteSubmitClick && !props.cmDetails?.isRowDeleted && <LoadingSkeletonForDelete />}
                                        {!(isDeleteSubmitClick && !props.cmDetails?.isRowDeleted) &&
                                            <>
                                                <Modal.Body className="text-justify">
                                                    {isErrorOnDeleteSubmit &&
                                                        <Row>
                                                            <Col className="mx-2">
                                                                <Alert className="mt-2" variant={errorTypeOnDeleteSubmit === "E" ? "danger" : getErrorType(editClickTr) === "W" ? "warning" : ""}>
                                                                    <Row>
                                                                        <Col className="col-1">
                                                                            {getErrorType(editClickTr) === "E" &&
                                                                                <FontAwesomeIcon icon={faExclamationCircle}
                                                                                    className="mr-1" style={exeptionColor} />
                                                                            }
                                                                            {getErrorType(editClickTr) === "W" &&
                                                                                <FontAwesomeIcon icon={faExclamationTriangle}
                                                                                    className="mr-1" style={warningColor} />
                                                                            }
                                                                        </Col>
                                                                        <Col>
                                                                            {errorMessageOnDeleteSubmit}
                                                                        </Col>
                                                                    </Row>
                                                                </Alert>
                                                            </Col>
                                                        </Row>
                                                    }
                                                    <span>Are you sure you want to delete this contribution record?</span>
                                                </Modal.Body>
                                                <div className="border-top mt-4 p-3">
                                                    <Button className="btn-block-xs-only float-right" variant="primary" disabled={!(errorCSSForSSN === "" && errorCSSForPayrollDate === "")}
                                                        onClick={() => { deleteRow(); }}>Submit</Button>
                                                    <Button onClick={() => { setShowDeletePopup(false); clearData(); }} className="btn-block-xs-only float-right mr-sm-3"
                                                        variant="secondary">Cancel</Button>
                                                </div>
                                            </>
                                        }
                                    </Modal>
                                </div>
                            </Col>
                        </Row>
                    }
                </>
                :
                <Alert className="mt-2" variant="danger">Unable to fetch Contribution Details: {props.cmDetails?.errorMessage}</Alert>
            }
        </>
    )
}

const loadingHeigthHeader = {
    height: "30px"
}
const loadingHeigthTD = {
    height: "20px"
}
const LoadingSkeleton = () => (
    <div className="row container">
        <div className="col-12 pl-2">
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
            <div className="mt-2"><Skeleton width={'100%'} /></div>
            <div><Skeleton width={'95%'} /></div>
        </div>
    </div>
);
const LoadingSkeletonForSummary = () => (
    <div className="row">
        <div className="col-7 pl-0">
            <div className="mt-2"><Skeleton style={loadingHeigthHeader} width={'20em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div className="mt-3"><Skeleton width={'20em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div className="mt-3"><Skeleton width={'20em'} /></div>
            <div className="mt-3">
                <div className="mt-3"><Skeleton style={loadingHeigthHeader} width={'15em'} /></div>
                <div><Skeleton width={'15em'} /></div>
                <div><Skeleton width={'15em'} /></div>
                <div><Skeleton width={'15em'} /></div>
                <div className="mt-3"><Skeleton width={'15em'} /></div>
                <div className="mt-2"><Skeleton width={'20em'} /></div>
            </div>
        </div>
        <div className="col-4 pl-0"></div>
    </div>

);
const LoadingSkeletonForAddEdit = () => (
    <div className="ml-2">
        <div className="mt-2"><Skeleton width={'30%'} /></div>
        <div><Skeleton width={'90%'} /></div>
        <div className="mt-2"><Skeleton width={'30%'} /></div>
        <div><Skeleton width={'90%'} /></div>
        <div className="mt-2"><Skeleton width={'30%'} /></div>
        <div><Skeleton width={'90%'} /></div>
        <div className="mt-2"><Skeleton width={'30%'} /></div>
        <div><Skeleton width={'90%'} /></div>
        <div className="mt-2"><Skeleton width={'30%'} /></div>
        <div><Skeleton width={'90%'} /></div>
        <div className="mt-2"><Skeleton width={'30%'} /></div>
        <div><Skeleton width={'90%'} /></div>
        <div className="mt-2"><Skeleton width={'30%'} /></div>
        <div><Skeleton width={'90%'} /></div>
        <div className="mt-2"><Skeleton width={'30%'} /></div>
        <div><Skeleton width={'90%'} /></div>
        <div className="mt-2"><Skeleton width={'30%'} /></div>
        <div><Skeleton width={'90%'} /></div>
    </div>

);
const LoadingSkeletonForDelete = () => (
    <div className="ml-2">
        <div className="mt-2"><Skeleton width={'30%'} /></div>
        <div><Skeleton width={'90%'} /></div>

    </div>

);

const LoadingSkeletonForTable = () => (

    <>
        <Table className="table table-bordered table-striped table-fixed" style={{ fontSize: "14px" }}>
            <thead>
                <tr className="border-bottom pl-2 table-borderless" style={{ display: "table", width: "100%", tableLayout: "fixed", minWidth: "880px" }}>
                    <th> <div className="p-1"><Skeleton style={loadingHeigthHeader} width={'100%'} /></div> </th>
                    <th> <div className="p-1"><Skeleton style={loadingHeigthHeader} width={'100%'} /></div> </th>
                    <th> <div className="p-1"><Skeleton style={loadingHeigthHeader} width={'100%'} /></div> </th>
                    <th> <div className="p-1"><Skeleton style={loadingHeigthHeader} width={'100%'} /></div> </th>
                    <th> <div className="p-1"><Skeleton style={loadingHeigthHeader} width={'100%'} /></div> </th>
                    <th> <div className="p-1"><Skeleton style={loadingHeigthHeader} width={'100%'} /></div> </th>
                </tr>
            </thead>
            <tbody style={{ height: "280px" }}>
                <tr style={{ display: "table", width: "100%", tableLayout: "fixed", minWidth: "880px" }}>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                </tr>

                <tr style={{ display: "table", width: "100%", tableLayout: "fixed", minWidth: "880px" }}>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                </tr>

                <tr style={{ display: "table", width: "100%", tableLayout: "fixed", minWidth: "880px" }}>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                </tr>

                <tr style={{ display: "table", width: "100%", tableLayout: "fixed", minWidth: "880px" }}>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                </tr>
                <tr style={{ display: "table", width: "100%", tableLayout: "fixed", minWidth: "880px" }}>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                </tr>

                <tr style={{ display: "table", width: "100%", tableLayout: "fixed", minWidth: "880px" }}>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                    <td className="p-2 my-5"> <Skeleton style={loadingHeigthTD} width={'100%'} /> </td>
                </tr>

            </tbody>
        </Table>
    </>

);
const LoadingForNameBySSN = () => (
    <div className="col-5 pl-0">
        <div><Skeleton style={loadingHeigthHeader} width={'10em'} /></div>
    </div>
);


function mapStateToProps(state: AppState) {
    return {
        cmDetails: state.cmDetails,
        dcr: state.dcr,
        currentUser: state.dcr.currentuserInfo.user,
        currentUserPermissions: state.dcr.currentuserInfo?.user?.permissions
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({ ...detailsActionCreators, ...schedulePaymentActionCreators, ...historyActionCreators }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContributionDetails);